<!-- Slide-out menu backdrop -->
<div
  class="menu-backdrop"
  [class.menu-backdrop--visible]="menuOpen"
  (click)="closeMenu()"
  aria-hidden="true">
</div>

<!-- Slide-out menu panel -->
<div id="navigation-menu" class="menu-panel" [class.menu-panel--open]="menuOpen" [inert]="!menuOpen" role="dialog" [attr.aria-label]="'Navigation menu' | translate">
  <div class="menu-panel__content">
    <header class="menu-panel__header">
      <h1 class="menu-panel__title">SNCRP</h1>
    </header>

    <div class="menu-panel__welcome">
      <img class="menu-panel__user-picture" [src]="profilePhotoUrl" alt="" />
      <div class="menu-panel__welcome-message">
      <span class="menu-panel__welcome-label">{{ 'Welcome back' | translate }}</span>
      <span class="menu-panel__welcome-name">{{ displayName }}!</span>
      </div>
    </div>

    <div class="menu-panel__actions">
      <a class="nav-action" [routerLink]="['/Incidents', 'Create']">
        <img class="nav-action__icon" src="assets/icons/plus.svg" alt="" aria-hidden="true" />
        <span class="nav-action__label">{{ 'Add' | translate }}</span>
      </a>
    </div>
    <nav class="menu-panel__nav" [attr.aria-label]="'Primary' | translate">
      <div class="menu-navigation">
      <div class="menu-navigation__root" [inert]="activeSubmenu !== null">
      <div class="app-menu__title">{{ 'Navigation' | translate }}</div>
      <ol class="nav-list">
        @for (item of navItems; track item.id) {
          @if (isItemVisible(item)) {
            <li class="nav-list__item">
              @if (item.children) {
                <button class="nav-list__link nav-list__link--children" type="button"
                   [class.nav-list__link--active]="isNavItemActive(item)"
                   [attr.aria-expanded]="activeSubmenu?.id === item.id"
                   [attr.aria-controls]="'submenu-' + item.id"
                   (click)="openSubmenu(item, $event)">
                  <img class="nav-list__icon" [src]="'assets/icons/' + item.icon" alt="" aria-hidden="true" />
                  <span class="nav-list__label">{{ item.label | translate }}</span>
                </button>
              } @else if (item.route) {
                <a class="nav-list__link"
                   [routerLink]="item.route"
                   routerLinkActive="nav-list__link--active">
                  @if (item.icon) {
                    <img class="nav-list__icon" [src]="'assets/icons/' + item.icon" alt="" aria-hidden="true" />
                  }
                  <span class="nav-list__label">{{ item.label | translate }}</span>
                </a>
              }
              @if (item.externalUrl) {
                <a class="nav-list__link nav-list__link--external"
                   [href]="item.externalUrl"
                   target="_blank"
                   rel="noopener noreferrer">
                  @if (item.icon) {
                    <img class="nav-list__icon" [src]="'assets/icons/' + item.icon" alt="" aria-hidden="true" />
                  }
                  <span class="nav-list__label">{{ item.label | translate }}</span>
                </a>
              }
            </li>
          }
        }
      </ol>
      </div>
      @for (item of navItems; track item.id) {
        @if (item.children && isItemVisible(item)) {
          <div class="nav-submenu" [id]="'submenu-' + item.id"
               [class.nav-submenu--open]="activeSubmenu?.id === item.id"
               [inert]="activeSubmenu?.id !== item.id">
            <button class="app-menu__title app-menu__title--back" type="button" (click)="openItemId = null">
              {{ item.label | translate }}
            </button>
            <ol class="nav-list">
              @for (child of item.children; track child.id) {
                <li class="nav-list__item">
                  @if (child.route) {
                    <a class="nav-list__link" [routerLink]="child.route" routerLinkActive="nav-list__link--active">
                      <span class="nav-list__label">{{ child.label | translate }}</span>
                    </a>
                  } @else if (child.externalUrl) {
                    <a class="nav-list__link nav-list__link--external" [href]="child.externalUrl" target="_blank" rel="noopener noreferrer">
                      <span class="nav-list__label">{{ child.label | translate }}</span>
                    </a>
                  }
                </li>
              }
            </ol>
          </div>
        }
      }
      </div>
    </nav>
  </div>
</div>

<!-- User popover (outside rail so it overlaps) -->
@if (showUserPopover) {
<div class="user-popover" role="dialog" [attr.aria-label]="'User information' | translate">
  <div class="user-popover__backdrop" (click)="closeUserPopover()" aria-hidden="true"></div>
  <div class="user-popover__card">
    <!-- Avatar circle with person icon -->
    <!-- <div class="user-popover__avatar" aria-hidden="true">
      <svg class="user-popover__avatar-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
           fill="currentColor">
        <path d="M12 12c2.761 0 5-2.239 5-5s-2.239-5-5-5-5 2.239-5 5 2.239 5 5 5zm0 2c-3.337 0-10 1.676-10 5v2h20v-2c0-3.324-6.663-5-10-5z"/>
      </svg>
    </div> -->

    <!-- User details -->
    <div class="user-popover__info">
      <div class="user-popover__name">{{ displayName || '—' }}</div>
      <div class="user-popover__email">{{ userEmail || '—' }}</div>
      @if (designation) {
        <div class="user-popover__designation">{{ designation }}</div>
      }
      @if (department) {
        <div class="user-popover__department">{{ department }}</div>
      }
      @if (company) {
        <div class="user-popover__company">{{ company }}</div>
      }
    </div>
  </div>
</div>
}

<!-- App shell -->
<div class="app-ui">
  <app-environment-banner></app-environment-banner>
  <app-user-notification-banner></app-user-notification-banner>

  <div class="app-ui__row">
  <!-- 60px left rail -->
  <div class="primary-rail">
    <!-- Burger at top -->
    <button class="rail-burger" (click)="toggleMenu()" [attr.aria-expanded]="menuOpen" aria-controls="navigation-menu" [attr.aria-label]="'Open navigation menu' | translate">
      <img src="assets/icons/menu.svg" alt="" aria-hidden="true" />
    </button>
    <button class="mobile-menu-close" [class.mobile-menu-close--visible]="menuOpen" [inert]="!menuOpen"
      (click)="closeMenu()" [attr.aria-label]="'Close navigation menu' | translate" aria-controls="navigation-menu">
      <img src="assets/icons/menu.svg" alt="" aria-hidden="true" />
    </button>

    <!-- Legacy rail actions are independent of the navbar's page-level visibility. -->
    @if (showRailCreateButton) {
      <div class="rail-create-host">
        <button class="rail-create" (click)="toggleCreateDropdown('rail', $event)"
          [attr.aria-expanded]="showCreateDropdown === 'rail'" [attr.aria-label]="'Create incident' | translate">
          <img src="assets/icons/plus.svg" alt="" aria-hidden="true" />
        </button>
        @if (showCreateDropdown === 'rail') {
          <div class="create-dropdown create-dropdown--right">
            <button class="create-dropdown__item" (click)="createFromScratch()">{{ 'Start from scratch' | translate }}</button>
            @if (sapQmEnabled) {
              <button class="create-dropdown__item" (click)="createFromSap()">{{ 'Import from SAP QM' | translate }}</button>
            }
          </div>
        }
      </div>
    }

    <!-- User avatar at bottom -->
    <button class="rail-user" (click)="toggleUserPopover()" [attr.aria-label]="'User profile' | translate">
      <span class="rail-user__avatar">
        <!-- <svg class="rail-user__avatar-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
             fill="currentColor" aria-hidden="true">
          <path d="M12 12c2.761 0 5-2.239 5-5s-2.239-5-5-5-5 2.239-5 5 2.239 5 5 5zm0 2c-3.337 0-10 1.676-10 5v2h20v-2c0-3.324-6.663-5-10-5z"/>
        </svg> -->
        <img class="rail-user__avatar-icon" [src]="isGod ? 'assets/icons/access_control.svg' : profilePhotoUrl" alt="" aria-hidden="true" />
      </span>
      @if (isAdmin && !isGod) {
        <span class="rail-user__admin-badge">A</span>
      }
    </button>
  </div>

  <div class="app-body" [style.padding-left]="appBodyPaddingLeft">
    <!-- Top navbar: left offset shifts right of wizard sidebar when active -->
    <!-- Matches legacy: .app__navbar { left: 100% of split-wrap } -->
    <header class="app-navbar" role="banner" [style.left]="navbarLeft">
      <div class="app-navbar__content">
        <!-- Row 1: Logo (left) + Language selector (right) — desktop only below title row -->
        <div class="app-navbar__row1">
          <img class="app-navbar__logo" src="assets/icons/logo-pg.png" alt="Hitachi Energy" width="300" height="24" />
          <!-- Language selector (non-supplier only, desktop) -->
          @if (!isSupplier) {
            <div class="lang-select">
              <label class="lang-select__label" for="lang-select">{{ 'Select Language' | translate }}</label>
              <select id="lang-select" class="lang-select__dropdown"
                [value]="currentLang"
                (change)="switchLang($any($event.target).value)">
                @for (lang of availableLanguages; track lang.code) {
                  <option [value]="lang.code">{{ lang.name }}</option>
                }
              </select>
            </div>
          }
        </div>

        <!-- Row 2: Page title (left) + Create incident button (right) — desktop only -->
        <div class="app-navbar__row2">
          @if (layoutService.navbarContent(); as navbarTpl) {
            <ng-container *ngTemplateOutlet="navbarTpl"></ng-container>
          } @else {
            <h1 class="app-navbar__title">{{ pageTitle | translate }}</h1>
          }
          @if (showCreateButton) {
            <div class="create-dropdown-host">
              <button class="btn-create-incident" (click)="toggleCreateDropdown('navbar', $event)"
                [attr.aria-expanded]="showCreateDropdown === 'navbar'">
                {{ 'Create incident' | translate }}
              </button>
              @if (showCreateDropdown === 'navbar') {
                <div class="create-dropdown create-dropdown--below">
                  <button class="create-dropdown__item" (click)="createFromScratch()">{{ 'Start from scratch' | translate }}</button>
                  @if (sapQmEnabled) {
                    <button class="create-dropdown__item" (click)="createFromSap()">{{ 'Import from SAP QM' | translate }}</button>
                  }
                </div>
              }
            </div>
          }
        </div>
      </div>
    </header>

    <!-- Main content -->
    <main class="app-main" id="main-content" tabindex="-1">
      <router-outlet></router-outlet>
    </main>
  </div>
  </div>
</div>
